import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-dashboard",
  templateUrl: "./med-icon-dashboard.component.html",
})
export class MedIconDashboardComponent extends SvgMixinComponent {}
